import { gql } from '@apollo/client'
import { ORDER_FIELDS, JOB_FIELDS, TRACKER_FIELDS, USER_FIELDS, REGION_FIELDS, BILTY_OPS_FIELDS } from './fragments'

export const GET_BILTY_OPS = gql`
	${BILTY_OPS_FIELDS}
	query BiltyOps($where: BiltyOpsWhere) {
		biltyOps(where: $where) {
			...BiltyOpsFields
		}
	}
`
export const GET_ALL_BILTY_OPS = gql`
	${BILTY_OPS_FIELDS}
	query BiltyOps {
		biltyOps {
			...BiltyOpsFields
		}
	}
`

export const GET_USER_WITH_EMAIL = gql`
	${USER_FIELDS}
	query Users($where: UserWhere) {
		users(where: $where) {
			...UserFields
		}
	}
`

export const GET_BILTY_OPS_WITH_EMAIL = gql`
	${BILTY_OPS_FIELDS}
	query BiltyOps($where: BiltyOpsWhere) {
		biltyOps(where: $where) {
			...BiltyOpsFields
		}
	}
`

export const GET_ALL_USERTYPES = gql`
	query UserTypes {
		userTypes {
			_id
			userType
		}
	}
`

export const GET_ALL_REGIONS = gql`
	${REGION_FIELDS}
	query Regions {
		regions {
			...RegionFields
		}
	}
`

export const GET_ALL_TRACKERS = gql`
	${TRACKER_FIELDS}
	query Trackers {
		trackers {
			...TrackerFields
		}
	}
`

export const GET_JOB_TYPE_STATUS = gql`
	${JOB_FIELDS}
	query Jobs($where: JobWhere, $options: JobOptions, $biltyOptions2: BiltyOptions) {
		jobs(where: $where, options: $options) {
			...JobFields
		}
	}
`

export const GET_TRACKER_JOBS = gql`
	query Jobs($where: JobWhere) {
		jobs(where: $where) {
			_id
			jobNumber
			Tracker {
				_id
				isConnected
				provider
				name
			}
			Lane {
				from {
					name
				}
				to {
					name
				}
			}
			Vehicle {
				registrationNumber
			}
			Driver {
				name
				phoneNumber
			}
			driverMatchedAt
			status
		}
	}
`

export const ADVANCED_SEARCH = gql`
	${ORDER_FIELDS}
	query Orders($where: OrderWhere, $movementsWhere2: MovementWhere, $options: OrderOptions, $biltyOptions2: BiltyOptions) {
		orders(where: $where, options: $options) {
			...OrderFields
		}
	}
`

export const GET_ALL_ORDERS = gql`
	${ORDER_FIELDS}
	query Orders($where: OrderWhere, $movementsWhere2: MovementWhere, $options: OrderOptions, $biltyOptions2: BiltyOptions) {
		orders(where: $where, options: $options) {
			...OrderFields
		}
	}
`
